import { createContext, useContext } from 'react'

import type { TokenOut } from '../api/client'

export type Status = 'loading' | 'anonymous' | 'must_change_password' | 'signed_in'

export interface Session {
  status: Status
  /** After login, sign-up or password change. */
  signedIn: (out: TokenOut) => void
  logout: () => Promise<void>
}

export const SessionContext = createContext<Session | null>(null)

export function useSession(): Session {
  const s = useContext(SessionContext)
  if (!s) throw new Error('useSession outside SessionProvider')
  return s
}
